/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileSmall } from "./_background/background-file-small.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileDiscSmall = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--small",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "small" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 40,
      height: 40,
      className: cls,
      "data-testid": "FileDiscSmall",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileSmall, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.333 13c0 4.3 2.368 6.667 6.667 6.667 4.299 0 6.666-2.368 6.666-6.667 0-4.3-2.367-6.667-6.666-6.667-4.3 0-6.667 2.368-6.667 6.667Zm2.222-.278c0-2.687 1.48-4.166 4.167-4.166v1.11c-2.056 0-3.056 1-3.056 3.056h-1.11Zm4.722 3.611c1.868 0 2.86-.827 3.028-2.519h1.117c-.189 2.346-1.643 3.63-4.145 3.63v-1.11ZM13 14.667c-1.122 0-1.667-.546-1.667-1.667s.545-1.667 1.667-1.667c1.121 0 1.666.546 1.666 1.667s-.545 1.667-1.666 1.667Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M19.66 13.247c-.09-4.141-2.448-6.417-6.663-6.417s-6.574 2.276-6.664 6.417a11.417 11.417 0 0 1-.003-.25c0-4.3 2.368-6.667 6.667-6.667 4.299 0 6.666 2.367 6.666 6.667 0 .084 0 .167-.002.25Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M8.57 12.719a6.758 6.758 0 0 0-.018.5h1.111c0-2.056 1-3.056 3.056-3.056v-.5c-2.056 0-3.056 1-3.056 3.056H8.57Zm4.704 4.722v.5c2.503 0 3.956-1.284 4.145-3.63h-.062c-.346 2.027-1.764 3.13-4.082 3.13Zm-1.934-4.194c.078.952.622 1.416 1.657 1.416 1.034 0 1.579-.464 1.657-1.416.006.08.01.163.01.25 0 1.121-.546 1.666-1.667 1.666-1.122 0-1.667-.545-1.667-1.666 0-.087.003-.17.01-.25Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    )
  );
};
export {
  FileDiscSmall
};
